export default __webpack_public_path__ + "static/media/circles.f8403604.svg";